import { dateService, monthsMap } from 'shared/lib/date';

import {
  SetCalendarButtonsStatusArgs,
  SetNextButtonStatusParams,
  SetPrevButtonStatusParams,
} from '../../types';

const disable = (button: Element | null) => {
  button?.classList.add('rdr-disabled');
  button?.setAttribute('disabled', 'true');
};

const enable = (button: Element | null) => {
  button?.classList.remove('rdr-disabled');
  button?.removeAttribute('disabled');
};

const setPrevButtonStatus = ({
  currentYear,
  minYear,
  currentMonth,
  minMonth,
  prevButton,
}: SetPrevButtonStatusParams) => {
  if (currentYear === minYear) {
    if (currentMonth <= minMonth) {
      disable(prevButton);
    } else {
      enable(prevButton);
    }
  } else if (currentYear < minYear) {
    disable(prevButton);
  } else {
    enable(prevButton);
  }
};

const setNextButtonStatus = ({
  currentYear,
  currentMonth,
  maxYear,
  maxMonth,
  nextButton,
}: SetNextButtonStatusParams) => {
  if (currentYear === maxYear) {
    if (currentMonth >= maxMonth) {
      disable(nextButton);
    } else {
      enable(nextButton);
    }
  } else if (currentYear > maxYear) {
    disable(nextButton);
  } else {
    enable(nextButton);
  }
};
export const setCalendarButtonsStatus = ({
  calendarRef,
  minDate,
  maxDate,
}: SetCalendarButtonsStatusArgs) => {
  // wait for Calendar to open to correctly set status on its initial render
  setTimeout(() => {
    if (!calendarRef.current) return;

    const currentMonthAndYearTitle = calendarRef.current.querySelector(
      '.rdrMonthAndYearPickers',
    );

    if (!currentMonthAndYearTitle) return;

    const prevButton = calendarRef.current.querySelector('.rdrPprevButton');
    const nextButton = calendarRef.current.querySelector('.rdrNextButton');

    const currentYearName = currentMonthAndYearTitle.textContent?.split(' ')[1];
    const currentMonthName = currentMonthAndYearTitle.textContent
      ?.split(' ')[0]
      .toLowerCase();

    const currentYear = currentYearName ? parseInt(currentYearName) : 0;
    const currentMonth = monthsMap[String(currentMonthName)];
    const minMonth = dateService.getDayJSObject(minDate).month();
    const minYear = dateService.getDayJSObject(minDate).year();
    const maxMonth = dateService.getDayJSObject(maxDate).month();
    const maxYear = dateService.getDayJSObject(maxDate).year();

    const prevButtonStatusArgs = {
      currentYear,
      minYear,
      currentMonth,
      minMonth,
      prevButton,
    };
    const nextButtonStatusArgs = {
      currentYear,
      currentMonth,
      maxYear,
      maxMonth,
      nextButton,
    };

    setPrevButtonStatus(prevButtonStatusArgs);
    setNextButtonStatus(nextButtonStatusArgs);
  });
};
